document.addEventListener("ajaxloader:render", notifyPopupOpenEvent, {once:true});
document.addEventListener("DOMContentLoaded", notifyPopupOpenEvent, {once:true});

console.log('form-popup.js.liquid-1');

function notifyPopupOpenEvent(){
  // Handle click on links with href="#wear-form"
  document.querySelectorAll('a[href="#wear-form"]').forEach(function(link) {

    link.addEventListener('click', function() {
      document.querySelector('.oos_form').classList.add('popup-show');

      var Notification = this.getAttribute('notification');
      // console.log(Notification,'Notification');
      if (Notification) {
        document.querySelector('.oos_form input[name="User From"]').value = Notification;
      }
    
      if (this.getAttribute('current-product')) {
        var CurrentProductUrl = this.getAttribute('current-product');
        var CurrentProductTitle = this.getAttribute('product-title');
        
        // var GetCurrentProductTitle = CurrentProductUrl.split("/");
        // var CurrentProductTitle = GetCurrentProductTitle[2].replace(/-/g, " ");
        
        document.querySelector('.oos_form input[name="Url"]').value = 'https://www.wearcomet.com' + CurrentProductUrl;
        document.querySelector('.oos_form input[name="Title"]').value = CurrentProductTitle;
      }
    });
  });
}

console.log('form-popup.js.liquid-2');

// Handle popup close button click
document.addEventListener('click', function (e) {
  console.log('form-popup.js.liquid-3');

  if (e.target.closest('.oos_form .popup-close')) {
    console.log('form-popup.js.liquid-4');

    const oosForm = document.querySelector('.oos_form');
    if (oosForm?.classList.contains('popup-show')) {
      oosForm.classList.remove('popup-show');
    }

    setTimeout(() => {
      const showForm = document.getElementById('wear-comet');
      if (showForm) {
        showForm.style.display = 'block';
        if (showForm.tagName.toLowerCase() === 'form') {
          showForm.reset();
        }
      }

      const thankYou = document.querySelector('.oos_form .thank-you-message');
      if (thankYou) thankYou.style.display = 'none';

      const formTitle = document.querySelector('.oos_form #form-title');
      if (formTitle) formTitle.style.display = 'block';
    }, 1000);
  }
});

// Handle modal overlay click
document.addEventListener('click', function(e) {
  if (e.target.matches('.oos_forms.modal-overlay')) {
    var oosForm = document.querySelector('.oos_form');
    if(oosForm.classList.contains('popup-show')){
      oosForm.classList.remove('popup-show');
    }

    setTimeout(() => {
      var ShowForm = document.getElementById('wear-comet');
      ShowForm.style.display = "block";
      document.querySelector('.oos_form .thank-you-message').style.display = 'none';
      document.querySelector('.oos_form #form-title').style.display = 'block';
      ShowForm.reset();
    }, 1000);
  }
});
  
window.addEventListener("load", function() {
  // Update Variant
  document.addEventListener('product:variant:changed', function(e){
    const data = e['detail'];
    if(data && data['variant']){
      const variant_name = data['variant']['name'];
      window.wc_current_selected_variant = variant_name;
    }else{
      window.wc_current_selected_variant = null;
    }
    // console.log(window.wc_current_selected_variant);
  });
});

function notifyForm(){
  const form = document.getElementById('wear-comet');
  form.addEventListener("submit", function(e) {
    e.preventDefault();
    document.querySelector("#wear-comet .submit-button").disabled = true;
    document.getElementById("popup-form-btn-loader").style.display = "block";
    document.getElementById("popup-form-btn-text").style.display = "none";
    const data = new FormData(form);

    // Update Variant Data
    if(window.wc_current_selected_variant){
      data.append('Variant Name', window.wc_current_selected_variant);
    }
    
    const action = e.target.action;
    fetch(action, {
      method: 'POST',
      body: data,
    })
    .then(() => {
      form.style.display = "none";
      document.querySelector('.oos_form .thank-you-message').style.display = 'block';
      document.getElementById("popup-form-btn-loader").style.display = "none";
      document.getElementById("popup-form-btn-text").style.display = "block";
      document.querySelector("#wear-comet .submit-button").disabled = false;
      document.querySelector('#form-title').style.display = 'none';
    });
  });
}

notifyForm();